import { IApiClient } from '../interfaces/IApiClient';

export interface IMessageTemplate {
  id: string;
  title: string;
  body: string;
  charLimit: number;
  isDefault?: boolean;
  sidTemplate?: string;
  supportedChannels?: string[];
  channelStatuses?: Array<{
    channel: string;
    status: string;
  }>;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: string;
    name: string;
    email: string;
  };
}

export interface CreateMessageTemplateDto {
  title: string;
  body: string;
  sidTemplate?: string;
}

export interface UpdateMessageTemplateDto {
  title?: string;
  body?: string;
  sidTemplate?: string;
}

export class MessageTemplateService {
  constructor(private apiClient: IApiClient) {}

  async getAllTemplates(): Promise<IMessageTemplate[]> {
    return this.apiClient.get('/message-templates');
  }

  async getTemplateById(id: string): Promise<IMessageTemplate> {
    return this.apiClient.get(`/message-templates/${id}`);
  }

  async createTemplate(dto: CreateMessageTemplateDto): Promise<IMessageTemplate> {
    return this.apiClient.post('/message-templates', dto);
  }

  async updateTemplate(
    id: string,
    dto: UpdateMessageTemplateDto
  ): Promise<IMessageTemplate> {
    return this.apiClient.put(`/message-templates/${id}`, dto);
  }

  async deleteTemplate(id: string): Promise<{ message: string }> {
    return this.apiClient.delete(`/message-templates/${id}`);
  }
}
